module.exports = __webpack_public_path__ + "media/theme/icon__discover-bb0e680b.png";